// eslint-disable-next-line max-len
export const findCategory = (state) => (categoryId) => state.all.find((category) => category.id === categoryId);
export const findCategoryByCodename = (state) => (codename) => state.all.find((category) => category.codename === codename);
export const findProduct = (state) => (productId, excludedCategory) => {
  let availableCategories = state.all;
  if (excludedCategory) {
    availableCategories = state.all.filter((c) => c.id !== excludedCategory);
  }

  let product = null;
  availableCategories.forEach((c) => {
    if (c.products && c.products.length > 0) {
      const match = c.products.find((p) => p.id === productId);
      if (match && !product) {
        product = match;
      }
    }
  });

  return product;
};
